





























































































































import { ConfirmApproveRequestModal, ConfirmDeclineRequestModal } from '@/components/admin-panel';
import {Empty, GeekWithStatus, GeekStatus, PendingUser, SearchFilter, PhraseSearchFilter} from '@/models';
import { Actions, typedStore } from '@/store';
import { ToastsService } from '@/utils';
import { debounce } from 'lodash';
import Vue from 'vue';

export default Vue.extend({
  name: 'GeeksManagementView',
  components: {
    ConfirmApproveRequestModal,
    ConfirmDeclineRequestModal,
  },
  data() {
    return {
      geekStatuses: Object.values(GeekStatus),
      userContext: Empty.pendingUser as PendingUser,
      loader: {
        isAccessRequestsListFetching: true,
        isGeeksListFetching: true,
      },
      filters: {
        debounce: {
          searchPhrase: '',
        } as PhraseSearchFilter,
      },
    };
  },
  async created(): Promise<void> {
    try {
      await this.$store.dispatch(Actions.management.geeksManagement.fetchGeeks);
      await this.$store.dispatch(Actions.management.geeksManagement.fetchAccessRequests);
    } finally {
      this.loader.isAccessRequestsListFetching = false;
      this.loader.isGeeksListFetching = false;
    }
  },
  computed: {
    geeks(): GeekWithStatus[] {
      return typedStore(this).state.management.geeksManagement.geeks;
    },
    geeksCount(): number {
      return typedStore(this).state.management.geeksManagement.pagination.totalCount;
    },
    accessRequests(): PendingUser[] {
      return typedStore(this).state.management.geeksManagement.accessRequests;
    },
    areMoreItemsAvailable(): boolean {
      return this.geeks.length < this.geeksCount && this.geeks.length > 0;
    },
  },
  methods: {
    async loadGeeks() {
      this.loader.isGeeksListFetching = true;
      try {
        await this.$store.dispatch(Actions.management.geeksManagement.fetchGeeks, this.filters.debounce);
      } finally {
        this.loader.isGeeksListFetching = false;
      }
    },
    async loadMoreGeeks() {
      this.loader.isGeeksListFetching = true;
      try {
        await this.$store.dispatch(Actions.management.geeksManagement.fetchMoreGeeks, this.filters.debounce);
      } finally {
        this.loader.isGeeksListFetching = false;
      }
    },
    async changeStatus(geek: GeekWithStatus, status: GeekStatus) {
      if (geek.status === status) {
        return;
      }

      await this.$store.dispatch(Actions.management.geeksManagement.changeGeeksStatus, {
        id: geek.id,
        status,
      });

      const toastText =
        this.$t(
          'management-panel.geeks-management.notifications.changed-status',
          {
            firstName: geek.firstName,
            lastName: geek.lastName,
            status: this.$t(`management-panel.geeks-management.user-statuses.${status}`),
          },
        ) as string;
      status === GeekStatus.Active ? ToastsService.success(toastText) : ToastsService.warning(toastText);
    },
    openApproveRequestModal(user: PendingUser) {
      this.userContext = user;
      this.$bvModal.show('approve-request-modal');
    },
    openDeclineRequestModal(user: PendingUser) {
      this.userContext = user;
      this.$bvModal.show('decline-request-modal');
    },
    async approveRequest(user: PendingUser) {
      await this.$store.dispatch(Actions.management.geeksManagement.approveAccessRequest, this.userContext.id);
      ToastsService.success(
        this.$t(
          'management-panel.geeks-management.notifications.request-approved',
          {
            firstName: user.firstName,
            lastName: user.lastName,
          },
        ) as string,
      );
      this.$bvModal.hide('approve-request-modal');
      await this.$store.dispatch(Actions.management.geeksManagement.fetchAccessRequests);
      await this.loadGeeks();
    },
    async declineRequest(user: PendingUser) {
      await this.$store.dispatch(Actions.management.geeksManagement.declineAccessRequest, this.userContext.id);
      ToastsService.warning(
        this.$t(
          'management-panel.geeks-management.notifications.request-declined',
          {
            firstName: user.firstName,
            lastName: user.lastName,
          },
        ) as string,
      );
      this.$bvModal.hide('decline-request-modal');
      await this.$store.dispatch(Actions.management.geeksManagement.fetchAccessRequests);
    },
    updateSearchPhrase: debounce(function(this: any) {
      this.filters.debounce.searchPhrase = this.$refs.searchPhrase.$el.value;
    }, 1000),
  },
  watch: {
    filters: {
      handler() {
        this.loadGeeks();
      },
      deep: true,
    },
  },
});
